// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterPurposeCompute } from "hooks/filters/useFilterPurpose";

// #####################################################

const useSearchPurposeFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { purpose: searchForUrl } = query || {};

	// ** Filtr - Którzy szukają w celu
	const searchPurposeFilterData = useMemo(() => {
		const searchForKey =
			filterPurposeCompute.searchForUrlToKey(searchForUrl);
		return searchForKey
			? {
					label: t("filtersAndSelectors:purposeLabel"),
					selected: t(`filtersAndSelectors:purpose.${searchForKey}`),
			  }
			: null;
	}, [searchForUrl, language]);

	// #####################################################

	return searchPurposeFilterData;
};

// #####################################################

export default useSearchPurposeFilterData;

// #####################################################
